import { render, staticRenderFns } from "./HomeVideo.vue?vue&type=template&id=35eb4ca5&scoped=true"
import script from "./HomeVideo.vue?vue&type=script&lang=js"
export * from "./HomeVideo.vue?vue&type=script&lang=js"
import style0 from "./HomeVideo.vue?vue&type=style&index=0&id=35eb4ca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb4ca5",
  null
  
)

export default component.exports